export default __webpack_public_path__ + "static/media/dp-flask.7a6e3fd3.png";